import { TourStep } from "../page-tour.component";

export const DASHBOARD_TOUR_STEPS: TourStep[] = [
  {
    title: "tour.dashboard.s1.title",
    description: "tour.dashboard.s1.desc",
    icon: "ft-sun",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(250, 55%, 50%) 50%, hsl(280, 60%, 55%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(221, 83%, 68%), hsl(250, 55%, 50%))",
    svgPath:
      "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z",
  },
  {
    title: "tour.dashboard.s2.title",
    description: "tour.dashboard.s2.desc",
    icon: "ft-sidebar",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(221, 83%, 68%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(221, 83%, 72%), hsl(221, 83%, 53%))",
    svgPath: "M4 6h16M4 12h16M4 18h7",
  },
  {
    title: "tour.dashboard.s3.title",
    description: "tour.dashboard.s3.desc",
    icon: "ft-target",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(152, 68%, 38%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath:
      "M12 2a10 10 0 0110 10 10 10 0 01-10 10A10 10 0 012 12 10 10 0 0112 2m0 4a6 6 0 100 12 6 6 0 000-12m0 4a2 2 0 100 4 2 2 0 000-4",
  },
  {
    title: "tour.dashboard.s4.title",
    description: "tour.dashboard.s4.desc",
    icon: "ft-play-circle",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(200, 75%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(200, 75%, 60%), hsl(221, 83%, 53%))",
    svgPath:
      "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M10 8l6 4-6 4V8z",
  },
  {
    title: "tour.dashboard.s5.title",
    description: "tour.dashboard.s5.desc",
    icon: "ft-bell",
    accentGradient:
      "linear-gradient(135deg, hsl(25, 84%, 50%) 0%, hsl(32, 88%, 60%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(32, 88%, 65%), hsl(25, 84%, 50%))",
    svgPath:
      "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0",
  },
  {
    title: "tour.dashboard.s6.title",
    description: "tour.dashboard.s6.desc",
    icon: "ft-bar-chart-2",
    accentGradient:
      "linear-gradient(135deg, hsl(250, 55%, 50%) 0%, hsl(221, 83%, 53%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(250, 68%, 63%), hsl(221, 83%, 53%))",
    svgPath: "M18 20V10M12 20V4M6 20v-6",
  },
  {
    title: "tour.dashboard.s7.title",
    description: "tour.dashboard.s7.desc",
    icon: "ft-heart",
    accentGradient:
      "linear-gradient(135deg, hsl(25, 84%, 50%) 0%, hsl(350, 65%, 55%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(350, 65%, 65%), hsl(25, 84%, 50%))",
    svgPath:
      "M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z",
  },
  {
    title: "tour.dashboard.s8.title",
    description: "tour.dashboard.s8.desc",
    icon: "ft-video",
    accentGradient:
      "linear-gradient(135deg, hsl(250, 55%, 50%) 0%, hsl(250, 68%, 63%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(250, 68%, 68%), hsl(250, 55%, 50%))",
    svgPath:
      "M23 7l-7 5 7 5V7zM14 5H3a2 2 0 00-2 2v10a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2z",
  },
  {
    title: "tour.dashboard.s9.title",
    description: "tour.dashboard.s9.desc",
    icon: "ft-book-open",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(170, 55%, 45%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(170, 55%, 45%))",
    svgPath:
      "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z",
  },
  {
    title: "tour.dashboard.s10.title",
    description: "tour.dashboard.s10.desc",
    icon: "ft-moon",
    accentGradient:
      "linear-gradient(135deg, hsl(230, 35%, 18%) 0%, hsl(250, 40%, 30%) 50%, hsl(221, 83%, 53%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(250, 40%, 40%), hsl(230, 35%, 18%))",
    svgPath: "M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z",
  },
  {
    title: "tour.dashboard.s11.title",
    description: "tour.dashboard.s11.desc",
    icon: "ft-check-circle",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(221, 83%, 53%) 50%, hsl(250, 55%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath: "M22 11.08V12a10 10 0 11-5.93-9.14 M22 4L12 14.01l-3-3",
  },
];

export const DASHBOARD_ASSISTANT_STEP: TourStep = {
  title: "tour.dashboard.assistant.title",
  description: "tour.dashboard.assistant.desc",
  icon: "ft-message-circle",
  accentGradient:
    "linear-gradient(135deg, hsl(262, 70%, 50%) 0%, hsl(221, 83%, 53%) 50%, hsl(190, 75%, 48%) 100%)",
  orbGradient:
    "radial-gradient(circle at 30% 30%, hsl(262, 70%, 62%), hsl(221, 83%, 53%))",
  svgPath:
    "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z M8 11a1 1 0 100-2 1 1 0 000 2z M12 11a1 1 0 100-2 1 1 0 000 2z M16 11a1 1 0 100-2 1 1 0 000 2z",
};
